export const DISCOVERY_COMMANDER = `
# Discovery: Commander

- Confirm repository root, active branch, package manager, and configured OpenCode runtime before delegating.
- Identify entry points, public exports, generated artifacts, and dynamic plugin hooks that can affect the mission.
- Turn unknowns into explicit questions or Planner tasks instead of treating assumptions as facts.
`;
